export default "__VITE_ASSET__1e8607c5__"